import * as R from 'ramda';

function isActiveCategory(category) {
    return R.anyPass([
        R.pathSatisfies(R.isNil, ['status', 'end']),
        R.pathSatisfies(R.isNil, ['status', 'endReason']),
        R.pathEq(true, ['status', 'optIn']),
    ])(category);
}

export default isActiveCategory;
